import { type ColDef } from 'ag-grid-community';
import { t } from 'i18next';
import { ArrowRight, PencilSquare } from 'react-bootstrap-icons';

import { ActionsGrid } from '@/app/components/grid';
import { type ActionColumn } from '@/app/components/grid/actions-column';
import { type CatalogTypeModel } from '../../models/Catalog';

export const getColumns = (
  onEdit: (catalog: CatalogTypeModel) => void,
  onViewValues: (catalog: CatalogTypeModel) => void
): Array<ColDef> => {
  const actions: Array<ActionColumn> = [
    {
      icon: PencilSquare,
      variant: 'secondary',
      onClick: async (row: CatalogTypeModel) => {
        onEdit(row);
      }
    },
    {
      icon: ArrowRight,
      variant: 'primary',
      onClick: async (row: CatalogTypeModel) => {
        onViewValues(row);
      }
    }
  ];

  const colDef: Array<ColDef> = [
    {
      headerName: t('common.label.actions'),
      cellRenderer: ActionsGrid,
      cellRendererParams: {
        actions: actions
      }
    },
    { headerName: t('common.label.name'), field: 'id' },
    {
      headerName: t('parameters-catalog.label.description'),
      field: 'description'
    },
    {
      headerName: t('parameters-catalog.label.parent'),
      field: 'parentTypeId',
      valueFormatter: (params: any) => {
        if (params.data.parent) {
          return params.data.parent.id;
        } else {
          return '';
        }
      }
    },
    { headerName: 'Private', field: 'isPrivate' }
  ];

  return colDef;
};
